export default __webpack_public_path__ + "static/media/figure2.cad1a980.png";